"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var propTypes = {
  cascadeStyle: _propTypes.default.bool,
  children: _propTypes.default.node,
  component: _propTypes.default.elementType,
  customStyle: _propTypes.default.any,
  roundMargin: _propTypes.default.string,
  sharpMargin: _propTypes.default.string
};
var _default = exports.default = propTypes;